/** Вход и первичная настройка библиотеки. */

import { useState } from 'react'
import { useAuth } from '../auth'

export function LoginPage() {
  const { configured, login, setup } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [repeat, setRepeat] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const isSetup = configured === false

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setError(null)
    if (isSetup && password !== repeat) {
      setError('Пароли не совпадают')
      return
    }
    if (isSetup && password.length < 8) {
      setError('Пароль должен быть не короче 8 символов')
      return
    }
    setBusy(true)
    try {
      if (isSetup) await setup(username.trim(), password)
      else await login(username.trim(), password)
    } catch (exc) {
      setError(describe(exc))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="center">
      <form className="form" onSubmit={submit}>
        <h1 style={{ margin: 0, color: 'var(--accent)' }}>Chita</h1>
        <p className="dim" style={{ margin: '0 0 0.5rem' }}>
          {isSetup
            ? 'Первый запуск: придумайте логин и пароль. Сервер доступен из интернета, поэтому пароль лучше сделать длинным.'
            : 'Домашняя библиотека книг'}
        </p>

        <label htmlFor="username">Логин</label>
        <input
          id="username"
          value={username}
          autoComplete="username"
          onChange={(event) => setUsername(event.target.value)}
          required
        />

        <label htmlFor="password">Пароль</label>
        <input
          id="password"
          type="password"
          value={password}
          autoComplete={isSetup ? 'new-password' : 'current-password'}
          onChange={(event) => setPassword(event.target.value)}
          required
        />

        {isSetup && (
          <>
            <label htmlFor="repeat">Пароль ещё раз</label>
            <input
              id="repeat"
              type="password"
              value={repeat}
              autoComplete="new-password"
              onChange={(event) => setRepeat(event.target.value)}
              required
            />
          </>
        )}

        {error && <div className="error">{error}</div>}

        <button className="btn btn--primary" type="submit" disabled={busy}>
          {busy ? 'Подождите…' : isSetup ? 'Создать' : 'Войти'}
        </button>
      </form>
    </div>
  )
}

function describe(error: unknown): string {
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as { message: unknown }).message)
  }
  return 'Не удалось войти'
}
